import { Button } from '@eigtech/ui-shared-dave'
import { useEndMeetingHelper } from '../../../hooks/useEndMeetingHelper'

export function EndMeetingControls() {
  const { canEndMeeting, canLeaveMeeting, endMeeting, isOrganizer, isPending, leaveMeeting } =
    useEndMeetingHelper()

  return (
    <>
      {canEndMeeting && (
        <Button
          colorScheme="red"
          isLoading={isPending}
          variant="outline"
          onClick={() => endMeeting()}
        >
          End Inspection
        </Button>
      )}
      {canLeaveMeeting && !isOrganizer && (
        <Button
          colorScheme="red"
          isLoading={isPending}
          variant="outline"
          onClick={() => leaveMeeting()}
        >
          Leave Inspection
        </Button>
      )}
    </>
  )
}
